import { Modifiers } from "popper.js";

interface Category {
   title: string;
   items: {
      title: string;
      href: string;
   }[];
}

export const MODIFIERS: Modifiers = {
   offset: {
      enabled: true,
      offset: "-50%p + 50%r",
   },
   preventOverflow: {
      enabled: true,
      padding: 8,
      boundariesElement: "window",
   },
   flip: {
      enabled: false,
   },
};

export const CATEGORIES: Category[][] = [
   [
      {
         title: "WORKSPACE",
         items: [
            { title: "On-Demand Office Space", href: "/flexible-office-space" },
            {
               title: "Dedicated Office Space",
               href: "/dedicated-office-space",
            },
         ],
      },
   ],
   [
      {
         title: "PORTFOLIO MANAGEMENT",
         items: LiquidSpaceConfig.ShowPortfolioManagerNavigationLinks ? [
            { title: "Workplace Management", href: "/workplace-manager" },
            { title: "Data & Insights", href: "/data-insights" },
            { title: "HQ Booking", href: "/hq-booking" },
            { title: "Portfolio Manager AI", href: "/portfolio-manager-ai"}
         ] : [
            { title: "Workplace Management", href: "/workplace-manager" },
            { title: "Data & Insights", href: "/data-insights" },
            { title: "HQ Booking", href: "/hq-booking" },
         ],
      },
   ],
   [
      {
         title: "EMPLOYEE EXPERIENCE",
         items: [{ title: "Team Connect", href: "/team-connect" }],
      },
      {
         title: "ENTERPRISE CAPABILITIES",
         items: [
            { title: "Data Security", href: "/data-security" },
            { title: "Integrations", href: "/integrations" },
         ],
      },
   ],
   [
      {
         title: "SERVICES",
         items: [
            {
               title: "Flex Advisory Services",
               href: "/flex-advisory-services",
            },
            { title: "Managed Office", href: "/managed-office" },
         ],
      },
   ],
];
